import gql from 'graphql-tag'

let cities = JSON.parse(localStorage.getItem('cities'));
let tempoOrderCities = cities.map(curnt => curnt.city);
tempoOrderCities = tempoOrderCities.length?JSON.stringify(tempoOrderCities):null;    //stringify array since query is a string

export const SUBSCRIBE_TEMPO_ORDERS = gql`
subscription tempoOrders($filterDate: date!){
 tempoOrders(where: {date: {_eq: $filterDate}}) {
    id
    tempoOrderCode
    contractorCode
    contractorId
    contractor{id name}
    date
    driverId
    driverDetail{id name}
    endReading
    startReading
    city
    City{id shortCode}
    tempoId
    tempo{id name platNo}
    orderDetailsArr{
    id
    lrObject
    order{
        id
        orderNumber
        clientobject
        pickuppartyobject
        droppingpartyobject
        materials
        note
          }
      }
    }
  }
 `

//Get TempoOrders Whose status is NULL
export const SUBSCRIBE_EXCEL_TEMPO_ORDERS = gql`
 subscription tempoOrders($startDate:date!, $endDate:date!, $city:String){
  tempoOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}}, {status: {_is_null: true}}, {endReading: {_eq: ""}},
                     { city: {_in: ${tempoOrderCities}}}, { city: {_eq: $city}}]},  order_by: {createdAt: desc}) {
    id
    tempoOrderCode
    contractorCode
    contractor{id name type}
    date
    city
    driverDetail{id name mobile}
    endReading
    startReading
    price
    tempo{id name platNo capacity}
    orderDetailsArr{id order{id materials}}
    }
 }
`
export const SUBSCRIBE_COMPLETED_TEMPO_ORDERS = gql`
 subscription tempoOrders($startDate:date!, $endDate:date!, $city:String){
  tempoOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}}, {status: {_is_null: true}}, {endReading: {_neq: ""}},
                     { city: {_in: ${tempoOrderCities}}}, { city: {_eq: $city}}]},  order_by: {createdAt: desc}) {
    id
    tempoOrderCode
    contractorCode
    contractor{id name type}
    date
    city
    driverDetail{id name mobile}
    endReading
    startReading
    price
    tempo{id name platNo capacity}
    orderDetailsArr{id order{id materials}}
    }
 }
`
export const SUBSCRIBE_CANCEL_TEMPO_ORDERS = gql`
 subscription cancel_tempoOrders($startDate:date!, $endDate:date!, $city:String){
  tempoOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}}, {status: {_eq: "Cancel"}}, { city: {_in: ${tempoOrderCities}}}, { city: {_eq: $city}}]},  order_by: {createdAt: desc}) {
    id
    tempoOrderCode
    contractorCode
    contractor{id name type}
    date
    city
    driverDetail{id name mobile}
    endReading
    startReading
    price
    tempo{id name platNo capacity}
    orderDetailsArr{id order{id materials}}
    }
 }
`
export const SUBSCRIBE_ORDERS_BY_TEMPO_ORDER_ID = gql`
 subscription orders_by_tempoOrderId($tempoOrderId: uuid!){
  orders(where: {orderDetails: {pickupVehicleAssignId: {_eq: $tempoOrderId}}}, order_by: {createdAt: desc}) {
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      createdAt
      updated_at
      materials
      priority
      note
      notes(order_by: {createdOn: desc}, limit: 1){id note}
      internalstatus
      internalStatus{id name viewPath}
      orderDetails {
        id
        lrObject
        pickupConfirmation
        orderReadiness
        dispactchVerification
        pickupVehicleAssignId
        transportVehicleAssignId
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        pickupPoint
        dropPoint
      }
    }
 }
`

// tempoOrders(where: {_and: {date: {_eq: $filterDate}, city: {_eq: $filterCity}}}) {
export const SUBSCRIBE_TEMPO_ORDERS_BY_DATE_AND_CITY = gql`
 subscription tempoOrders($filterDate: date!){
  tempoOrders(where: {_and: [{date: {_eq: $filterDate}},{endReading: {_eq: ""}}]}) {
    id
    tempo{ id name platNo type Contractor{id name type} }
    driverDetail{id name}
    orderDetailsArr{
      id
      order{
        id
        orderNumber
        pickuppartyobject
        droppingpartyobject
          }
       }
    }
 }
`
export const SUBSCRIBE_OCCUPIED_TEMPOS_AND_DRIVERS = gql`
subscription tempoOrders($todayDate: date!){
 occupiedTempoAndDriverIds: tempoOrders(where: {date: {_eq: $todayDate}}) {
    id
    tempoId
    driverId
    }
  }
 `
export const SUBSCRIBE_LAST_TEMPO_ORDER_CODE = gql`
subscription tempoOrders($todayDate: date!){
 lastTempoOrder: tempoOrders(where: {date: {_eq: $todayDate}}, order_by: {createdAt: desc}, limit: 1) {
      id
      tempoOrderCode
  }
  }
 `
export const SUBSCRIBE_TEMPO_ORDER_BY_ID = gql`
 subscription tempoOrderDetail($tempoOrderId: uuid!){
  tempoOrderDetail:tempoOrders(where: {id: {_eq: $tempoOrderId}}) {
    id
    tempoOrderCode
    contractorCode
    contractor{id name mobile type}
    date
    city
    driverDetail{id name mobile}
    endReading
    startReading
    price
    tempo{id name platNo capacity}
   }
 }
`
